import React from "react";
import { ShieldAlert } from "lucide-react";

export default function Disclaimer({ compact }) {
  if (compact) {
    return (
      <p data-testid="disclaimer-compact" className="text-[11px] leading-relaxed text-tc-muted font-mono">
        TRADECRAFT is an educational simulation. It does not execute real trades or provide
        investment advice. Trading involves risk. Simulated performance does not guarantee future results.
      </p>
    );
  }
  return (
    <div data-testid="disclaimer" className="tc-card p-4 flex gap-3 items-start bg-tc-card/60">
      <ShieldAlert className="w-4 h-4 mt-0.5 text-tc-pass shrink-0" />
      <p className="text-xs leading-relaxed text-tc-sub">
        <span className="text-tc-txt font-semibold">Educational Simulator.</span> TRADECRAFT does not
        execute real trades or provide investment advice. Market data is either{" "}
        <span className="font-mono text-tc-pass">SIMULATED</span> or replayed{" "}
        <span className="font-mono text-tc-coach">REAL HISTORY</span> — never live, never real money. Trading involves risk. Simulated
        performance does not guarantee future results.
      </p>
    </div>
  );
}
